import React from 'react';
import { useHistory } from 'react-router-dom';
import t from '@guestyci/localize/t.macro';
import { Button, Heading, Text, Stack } from '@guestyci/arc';
import { MailCheck } from '@guestyci/icons/system';

import { utils } from 'utils';

const ResetSentConfirmation = () => {
  const history = useHistory();

  const handleBackToSignIn = () => {
    utils.eventsLogger.unifiedLoginDio.track('back_to_sign_in', 'click');
    history.push('/login');
  };

  return (
    <Stack spacing={6} align="start" className="gst-pt-6 lg:gst-pt-0">
      <MailCheck size={64} strokeWidth={1.5} className="gst-text-primary" />

      <Stack spacing={2}>
        <Heading variant="h2">{t('Check your email')}</Heading>
        <Text type="secondary">
          {t('We sent you a link to reset your password')}
        </Text>
      </Stack>

      <Button
        type="button"
        className="gst-w-full"
        onClick={handleBackToSignIn}
      >
        {t('Back to sign in')}
      </Button>
    </Stack>
  );
};

export default ResetSentConfirmation;
